import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { getBetsInfo } from '../../utils/betsFields';
import normalizeString from '../../utils/normalize';
import BetsTable from '../betsTable/default';

const BetsRecords = () => {
  const { betname, page } = useParams();
  const [ totalPages, setTotalPages] = useState(0);
  const actualPage = Number(page) > 0 ? Number(page) : 1;
  const prevPage = actualPage - 1;
  const nextPage = actualPage + 1;
  const bets = getBetsInfo();
  const actualBet = bets.find((bet) =>(betname === normalizeString(bet.name)));

  const setPagination = (numOfRecords, totalRecords) =>{
    let numOfPages = Math.ceil(totalRecords / numOfRecords);
    setTotalPages(numOfPages);
  };


  return (<div className="container mt-4">

    <h4 className="display-4 text-center mb-4">
      <i className="fas fa-clipboard-list"></i> Formularios de loterías
    </h4>
    <div class="container my-5">
      <h2 class="mb-4">{`Registros de ${actualBet?.name}`}</h2>

      <BetsTable betName={betname} page={page} setPagination={setPagination}/>

      <nav aria-label="Paginación de tabla">
        <ul class="pagination justify-content-center">
          {actualPage > 1 ? <li class="page-item">
            <a href={`/admin/${betname}/${prevPage}`}><button class="page-link" id="prev-btn">Anterior</button></a>
          </li> : ''}
          <li class="page-item disabled">
            <span class="page-link" id="page-info">{`Página ${actualPage} de ${totalPages}`}</span>
          </li>
          {actualPage < totalPages ? <li class="page-item">
          <a href={`/admin/${betname}/${nextPage}`}><button class="page-link" id="next-btn">Siguiente</button></a>
          </li> : ''}
        </ul>
      </nav>
    </div>
  </div>)
};

export default BetsRecords;